// App
import { AppState } from 'state/types';
import getState from 'state/selectors';
import { HiddenWiki, hiddenWikiReduxKey } from 'ab-experiments/hidden-wiki';
import { isUserAuthenticated } from 'state/users/current-user/selectors';

import config from 'config';

// Module
import { AbTestsState } from './reducer';

export function getAbTests(state: AppState): AbTestsState {
  return getState(state).abTests;
}

export function isWikiHidden(state: AppState): boolean {
  const userAuthenticated = isUserAuthenticated(state);
  return (
    HiddenWiki.isHidden(getAbTests(state)[hiddenWikiReduxKey]) ||
    !config.wikiEnabled ||
    userAuthenticated !== true
  );
}

export default getAbTests;
